export default __webpack_public_path__ + "static/media/540.129ba704.jpg";